import usePosTaxLinkGuard from "./usePosTaxLinkGuard";

/**
 * Tax-system-aware POS linking guard (Egypt store/device + Syria station).
 * Kept under this name for existing call sites.
 */
export default function useEgyptPosStoreGuard() {
  return usePosTaxLinkGuard();
}
